import { yupLocalized } from "@ryde/shared";

export const dashboardViewEditValidation = {
  name: yupLocalized.string().required(),
  scope: yupLocalized.string().required(),
};
